module.exports = __webpack_public_path__ + "img/dateline_4.45407bbd.png";